<template>
	<div>
		<!-- <v-row dense>
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<div v-if="!isCompanyItemLoading">
					<company-form-4-person :disabled="!editMode" v-model="companyItem" />
				</div>
				<div v-else>
					<v-progress-linear indeterminate></v-progress-linear>
				</div>
			</v-col>
		</v-row>
		<v-row dense v-if="editMode">
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<standard-actions save cancel @save="save" @cancel="cancel" />
			</v-col>
		</v-row>
		<v-row dense v-else>
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<l-tooltip right>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" @click="enableEditMode" small :retain-focus-on-click="false">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('$global.actions.edit') }}</span>
				</l-tooltip>
			</v-col>
		</v-row> -->
		<v-row dense>
			<v-col cols="12" sm="6" md="6" lg="6" xl="6">
				<div v-if="true">
					<l-autocomplete
						disabled
						v-model="settingsStore.global.defaults.country"
						:items="$options.countriesArray"
						item-text="[1]"
						item-value="[0]"
						clearable
						clearvalue=""
						:label="$t('country')"
					></l-autocomplete>
				</div>
				<div v-else>
					<v-progress-linear indeterminate></v-progress-linear>
				</div>
			</v-col>
		</v-row>
		Default Values
	</div>
</template>

<script>
// globals
import countriesArray from '@/plugins/i18nCountries';
// locals
import i18n from './dictionary';
// models
// components
import LAutocomplete from '@/components/base/LAutocomplete.vue';
// store
import { useSettingsStore } from '@/plugins/settings/store';
import { mapStores } from 'pinia';

export default {
	name: `DefaultValuesTab`,
	components: { LAutocomplete },
	mixins: [],
	i18n,
	props: {},
	data() {
		return {};
	},
	computed: {
		...mapStores(useSettingsStore),
	},
	methods: {},
	created() {
		this.$options.countriesArray = countriesArray;
	},
};
</script>
